export default __webpack_public_path__ + "d6e043a28a3ebeb54ffe9cbe0963f78d.png";